import React from "react";
import {
  Grid,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import "./BenefitsAndFeaturesSection.scss";

interface BenefitsAndFeature {
  title: string;
  desc: string;
}

interface BenefitsAndFeaturesSectionProps {
  icon: any;
  feature: BenefitsAndFeature[];
  benefits: string[];
}

const BenefitsAndFeaturesSection: React.FC<BenefitsAndFeaturesSectionProps> = ({
  icon,
  feature,
  benefits,
}) => {
  return (
    <Box
      sx={{
        marginBottom: 2,
        display: "flex",
        border: "1px solid #E0E0E0",
        borderRadius: "25px",
        flexDirection: "row",
        width: "100%",
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <Typography variant="h4">{icon}</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={5}>
          <List>
            {feature.map((item, index) => (
              <>
                <ListItem
               
                  key={index}
                  sx={{
                    alignItems: "baseline",
                    paddingLeft: "4px",
                    paddingTop: "0px",
                  }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", marginRight: 1 }}>
                  </ListItemIcon>
                  <ListItemText  className="list-itembenifits" primary={item.title} secondary={item.desc} />
                </ListItem>
              </>
            ))}
          </List>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              backgroundColor: "#F4F4FF",
              borderTopRightRadius: "25px",
              borderBottomRightRadius: "25px",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                padding: 3,
              }}
            >
              <Typography variant="h6" fontWeight={700}>
                Benefits
              </Typography>
              <List>
                {benefits.map((benefit, index) => (
                  <ListItem
                    key={index}
                    sx={{
                      alignItems: "baseline",
                      paddingLeft: "4px",
                      paddingTop: "0px",
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: "auto", marginRight: 1 }}>
                      <FiberManualRecordIcon
                        sx={{ fontSize: "8px", color: "#000" }}
                      />
                    </ListItemIcon>
                    <ListItemText primary={benefit} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BenefitsAndFeaturesSection;
